import React, { useState, useEffect } from "react";


const LogsFilter = (props) => {

    const [dummyState, setDummyState] = useState(false);

    const runReset = () => {

    }

    const runFilter = () => {
        
    }

    return (
        <div style={{
            position: "absolute",
            // top: "10vh",
            left: "0",
            zIndex: "10",
            backgroundColor: "white",
            width: "100vw",
            padding: "1rem"
        }}>
            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Data Source</label>
                <select name="location" style={{"width": "200px"}}>
                    <option value="">None</option>
                    <option value="BPCS-HERMES">BPCS-HERMES</option>
                    <option value="CleverV3">CleverV3</option>
                    <option value="GTFSRTBuilder">GTFSRTBuilder</option>
                    <option value="PCSDATA">PCSDATA</option>
                    <option value="Zensor">Zensor</option>
                </select>
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>User Name</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Location ID</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Action Message</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Internal Trip Number</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Last Modified</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Status</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Action</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Action Source</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>IP Address</label>
                <input className="short-input" type="text" />
            </div>

            <div id="busops_filter_location" class="filter-field form-element-horizontal">
                <label>Process</label>
                <input className="short-input" type="text" />
            </div>

            <div className="filter-bar">
                <div className="option  " onClick={runReset}>Reset</div>
                <div id="busops_apply_filter" className="option  " onClick={runFilter}>Apply Filter</div>
            </div>
        </div>
    )
}

export default LogsFilter;